import { render, staticRenderFns } from "./menji.vue?vue&type=template&id=cae9d8bc&scoped=true"
import script from "./menji.vue?vue&type=script&lang=js"
export * from "./menji.vue?vue&type=script&lang=js"
import style0 from "./menji.vue?vue&type=style&index=0&id=cae9d8bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae9d8bc",
  null
  
)

export default component.exports